import EventEmitter from "eventemitter3";

const EventBus = new EventEmitter();

const EVENTS = {
  // Group related. Used by sidebar groups tree manipulation
  CURRENT_GROUP_UPDATED: "CURRENT_GROUP_UPDATED",
  NEW_GROUP_ADDED: "NEW_GROUP_ADDED",
  GROUP_RENAMED: "GROUP_RENAMED",
  GROUP_REMOVED: "GROUP_REMOVED",
  GROUP_UPDATED: "GROUP_UPDATED",
  GROUP_MOVED: "GROUP_MOVED",
  GROUP_ATTRS_UPDATED: "GROUP_ATTRS_UPDATED",
  GROUP_TAGS_UPDATED: "GROUP_TAGS_UPDATED",
  TEAM_OWNER_CHANGED: "TEAM_OWNER_CHANGED",
  // Fresh Group.supplyOwners landed after an owner edit's details refetch.
  // Payload { id, supplyOwners } lets pit-state surfaces (org chart card /
  // details panel) patch their owner pills immediately instead of waiting
  // for their full team reloads to return.
  TEAM_OWNERS_REFETCHED: "TEAM_OWNERS_REFETCHED",
  // Org Design Insights conventions / targets saved or instance root toggled
  INSIGHTS_WORKSPACE_CONFIG_CHANGED: "INSIGHTS_WORKSPACE_CONFIG_CHANGED",

  // Any GraphQL mutation that came back without errors. Payload { operationName }.
  // Lets read surfaces that are not tied to the written entity (e.g. the org
  // chart changelog panel) refresh after org writes without per-site wiring.
  GRAPHQL_MUTATION_COMPLETED: "GRAPHQL_MUTATION_COMPLETED",

  // Pagination
  LOAD_MORE_MEMBERS: "LOAD_MORE_MEMBERS",
  LOAD_MORE_TEAMS: "LOAD_MORE_TEAMS",

  // Members related.
  UPDATE_PEOPLE_AND_GROUPS: "UPDATE_PEOPLE_AND_GROUPS",

  // Sidebar related
  SIDEBAR_STATUS_CHANGED: "SIDEBAR_STATUS_CHANGED",

  // Tags navigation
  CURRENT_TAG_UPDATED: "CURRENT_TAG_UPDATED",

  // Active tenant updated
  ACTIVE_TENANT_UPDATED: "ACTIVE_TENANT_UPDATED",

  // Storage changed
  STORAGE_CHANGED: "STORAGE_CHANGED",

  // Org chart canvas "+1": expand every visible team by one level.
  ORG_CHART_EXPAND_ONE_LEVEL: "ORG_CHART_EXPAND_ONE_LEVEL",
  // Org chart canvas "-1": collapse the deepest open level. No fetch.
  ORG_CHART_COLLAPSE_ONE_LEVEL: "ORG_CHART_COLLAPSE_ONE_LEVEL",
  // Payload: { expandDisabled, collapseDisabled, expandTitle, collapseTitle }.
  ORG_CHART_ONE_LEVEL_CONTROLS: "ORG_CHART_ONE_LEVEL_CONTROLS",

  // Org chart design/edit mode toggled. Payload: { sessionKey, isEditMode }.
  // Lets surfaces outside the OrgChartDnDProvider tree (e.g. the team page
  // header) reflect the current mode without polling sessionStorage.
  ORG_CHART_EDIT_MODE_CHANGED: "ORG_CHART_EDIT_MODE_CHANGED",

  // Side navigation
  SIDE_NAV_PINNED_ITEMS_UPDATED: "SIDE_NAV_PINNED_ITEMS_UPDATED",

  // AI chat selected
  AI_DASHBOARD_SELECTED: "AI_DASHBOARD_SELECTED",
  AI_DASHBOARD_UPDATED: "AI_DASHBOARD_UPDATED",
  AI_DASHBOARD_BUILD_PROGRESS: "AI_DASHBOARD_BUILD_PROGRESS",
  AI_DASHBOARD_BUILD_STEP_DEBUG: "AI_DASHBOARD_BUILD_STEP_DEBUG",
};

export { EventBus, EVENTS, EventBus as default };
